<template>
  <lifecycle-stepper
    :steps="stepDefinitions"
    :current-step="step"
  />
</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import LifecycleStepper, { StepDefinition } from '../common/LifecycleStepper.vue';

export default defineComponent({
  components: {
    LifecycleStepper,
  },
  props: {
    lifecycleInfo: {
      type: Object as PropType<{
        PickupDateTime: string,
        DeliveryDateTime: string,
        Eta: string
    }>,
      required: true,
    },
    timezone: {
      type: Boolean,
      required: true
    },
    step: {
      type: Number,
      required: true,
    },
  },
  computed: {
    stepDefinitions(): StepDefinition[] {
      const info = this.lifecycleInfo;

      const isPickedUp = !!info.PickupDateTime;
      const isDelivered = !!info.DeliveryDateTime;
      const isInTransit = isPickedUp && !isDelivered;
      const hasTimezone = !!this.timezone;

      return [
        {
          header: 'Out for Delivery',
          subHeader: info.PickupDateTime || null,
        },
        {
          header: 'Estimated Arrival',
          subHeader: isInTransit && hasTimezone
            ? (info.Eta || 'No GPS Data')
            : isInTransit
              ? 'Invalid Zip Code, Unable to Calculate ETA'
              : null
        },
        {
          header: 'Delivered',
          subHeader: info.DeliveryDateTime || null,
        },
      ];
    },
  },
});
</script>

